var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTeamwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 853 1186"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#teamwork_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M85 1h767v570H85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M205 114h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M271 114h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M339 115.5h67v67h-67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M337 114h68v68h-68zM469 114h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M403 114h68v68h-68zM535 114h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M601 114h68v68h-68zM205 179h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M271 179h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M339 180.5h67v67h-67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M337 179h68v68h-68zM469 179h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M403 179h68v68h-68zM535 179h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M601 179h68v68h-68zM205 247h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M271 247h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M339 248.5h67v67h-67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M337 247h68v68h-68zM469 247h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M403 247h68v68h-68zM535 247h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M601 247h68v68h-68zM205 315h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M271 315h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M339 316.5h67v67h-67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M337 315h68v68h-68zM469 315h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M403 315h68v68h-68zM535 315h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M601 315h68v68h-68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221 449.5h249Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M221 449.5h249"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221 465.5h249Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M221 465.5h249"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M221 483h118.449Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M221 483h118.449"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m557 134.5 24.5 24.5Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m557 134.5 24.5 24.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m557 159 24.5-24.5Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m557 159 24.5-24.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M216 226c8.284 0 15-5.373 15-12s-6.716-12-15-12-15 5.373-15 12 6.716 12 15 12",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M216 227c8.617 0 16-5.624 16-13h-2c0 5.878-6.048 11-14 11zm16-13c0-7.376-7.383-13-16-13v2c7.952 0 14 5.122 14 11zm-16-13c-8.617 0-16 5.624-16 13h2c0-5.878 6.048-11 14-11zm-16 13c0 7.376 7.383 13 16 13v-2c-7.952 0-14-5.122-14-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m222.564 237.772-5 24 1.958.408 5-24zm-38.605 19.205 14.983-42.142-1.884-.67-15.458 43.476-.474 1.334 1.416.001 36.957.024h.805l.173-.786 4.5-20.5-1.954-.429-4.327 19.714z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m217.564 261.772-.204.979-.979-.204.204-.979zm5-24-.979-.204.204-.979.979.204zm-3.042 24.408.979.204-.204.979-.979-.204zm5-24 .204-.979.979.204-.204.979zm-25.58-23.345.335-.942.942.335-.335.942zm-14.983 42.142v1l-1.416-.001.474-1.334zm13.099-42.812-.942-.335.335-.942.942.335zM181.6 257.641l-.942-.335zm-.474 1.334v1l-1.416-.001.474-1.334zm1.416.001.001-1zm36.957.024.001-1zm.805 0 .977.215-.173.786-.804-.001zm.173-.786L219.5 258zm4.5-20.5.214-.976.977.214-.214.977zm-1.954-.429-.976-.214.214-.977.977.215zm-4.327 19.714.977.215-.173.786-.805-.001zm-2.111 4.569 5-24 1.958.408-5 24zm2.733 1.591-1.958-.408.408-1.958 1.958.408zm6.183-24.775-5 24-1.958-.408 5-24zm-2.733-1.591 1.958.408-.408 1.958-1.958-.408zm-22.884-21.623-14.983 42.142-1.884-.67L198 214.5zm-2.491-1.947 1.884.67-.67 1.884-1.884-.67zm-16.735 44.083 15.458-43.476 1.884.67-15.457 43.476zm-.474 1.334.474-1.334 1.885.67-.475 1.334zm2.357 1.336-1.415-.001.001-2 1.416.001zm36.958.024-36.958-.024.002-2L219.5 258zm.805 0h-.805l.001-2h.805zm1.15-1.571-.173.786-1.954-.429.173-.786zm4.5-20.5-4.5 20.5L219.5 258l4.5-20.5zm-2.716-1.62 1.953.429-.429 1.953-1.953-.429zm-5.519 20.476 4.328-19.714 1.953.429-4.327 19.714zm-33.759-.808 34.737.022-.002 2-34.736-.022zM86 1h767v32H86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M530.156 197.213c-2.804 3.398.144 8.63 4.542 8.371 4.574-.268 8.872-.122 9.891 1.215 2.372 3.116 6.03 7.9 6.03 7.9 1.345 4.836-4.742 8.192-8.114 4.473l-1.077-1.187-6.555-10.397a3.872 3.872 0 0 0-6.786 3.696l6.898 14.846a10.4 10.4 0 0 0 2.752 3.616c2.605 2.182 7.49 6.158 10.552 7.919 4.334 2.493 13.304 5.318 13.304 5.318l5.98 6.292a.7.7 0 0 0 .08.198l.779.707 4.966 5.225.513-.758 21.641-13.764-7.614-8.036-7.205-12.273-11.074-12.819c-5.505-6.372-12.846-10.742-20.58-14.075-4.358-1.878-13.647 1.005-16.936 2.137a4.47 4.47 0 0 0-1.987 1.396",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m534.698 205.584-.059-.998zm-4.542-8.371-.771-.637zm14.433 9.586-.796.606zm6.03 7.9.795-.607.117.153.052.186zm-8.114 4.473.741-.671zm-1.077-1.187-.74.672-.059-.065-.047-.074zm-6.555-10.397.845-.534zm-5.427-1.154.556.831zm-1.359 4.85.907-.422zm6.898 14.846-.907.421zm2.752 3.616-.642.766zm10.552 7.919.498-.867zm13.304 5.318.301-.954.246.078.178.187zm5.98 6.292.725-.688.187.196.061.264zm.08.198-.672.741-.108-.099-.076-.125zm.779.707.672-.741.027.025.026.027zm4.966 5.225.828.56-.697 1.03-.856-.901zm.513-.758-.828-.561.116-.171.175-.112zm21.641-13.764.726-.688.834.881-1.023.651zm-7.614-8.036-.726.687-.079-.083-.058-.098zm-7.205-12.273.757-.654.06.069.046.079zm-11.074-12.819.757-.653zm-20.58-14.075-.396.918zm-16.936 2.137-.326-.946zm2.614 10.766c-2.635.155-4.811-1.339-5.907-3.331-1.1-1.998-1.17-4.61.535-6.676l1.542 1.273c-1.099 1.332-1.097 3.036-.325 4.439.776 1.409 2.274 2.402 4.037 2.298zm9.036.822c-.069-.09-.292-.27-.841-.445-.523-.168-1.22-.294-2.071-.375-1.698-.163-3.856-.136-6.124-.002l-.118-1.997c2.306-.135 4.583-.169 6.433.008.923.088 1.777.233 2.489.461.687.219 1.383.56 1.823 1.138zm6.826 7.294-.794.607h-.001l-.002-.003-.008-.01-.031-.041-.12-.157-.447-.585-1.517-1.986a5116 5116 0 0 1-3.906-5.119l1.591-1.212a4775 4775 0 0 0 5.421 7.103l.447.584.12.157.031.041.008.01.002.003.001.001zm-7.373 3.802c2.664 2.937 7.472.286 6.41-3.534l1.927-.536c1.627 5.852-5.738 9.913-9.818 5.413zm-1.077-1.188 1.077 1.188-1.481 1.343-1.077-1.187zm-6.451-10.259 6.556 10.397-1.692 1.067-6.555-10.397zm-6.827-1.451a4.87 4.87 0 0 1 6.827 1.451l-1.691 1.067a2.87 2.87 0 0 0-4.025-.856zm-1.711 6.102a4.87 4.87 0 0 1 1.711-6.102l1.111 1.662a2.87 2.87 0 0 0-1.008 3.597zm6.898 14.846-6.898-14.846 1.814-.843 6.898 14.847zm3.017 3.961a11.4 11.4 0 0 1-3.017-3.961l1.814-.842a9.4 9.4 0 0 0 2.487 3.27zm10.695 8.02c-3.152-1.814-8.107-5.851-10.695-8.02l1.284-1.533c2.621 2.196 7.437 6.11 10.408 7.819zm13.803 4.451-.3.954h-.001l-.001-.001-.005-.001-.021-.007-.077-.025-.296-.095a138.356 138.356 0 0 1-4.669-1.61c-2.785-1.018-6.184-2.373-8.433-3.666l.997-1.734c2.085 1.199 5.339 2.504 8.123 3.522a134 134 0 0 0 4.886 1.678l.074.024.018.006.005.001h.001zm5.255 6.981-5.979-6.292 1.449-1.378 5.98 6.293zm-.051.026a1.7 1.7 0 0 1-.198-.486l1.947-.457a.3.3 0 0 0-.037-.09zm.963.93-.779-.706 1.344-1.482.779.707zm4.913 5.174-4.966-5.226 1.45-1.377 4.966 5.225zm2.066-.887-.513.758-1.656-1.12.513-.759zm21.35-13.48-21.641 13.764-1.074-1.688 21.641-13.764zm-7.425-9.568 7.614 8.036-1.452 1.376-7.614-8.037zm-7.068-12.091 7.204 12.272-1.725 1.013-7.204-12.273zm-11.18-12.966 11.074 12.818-1.513 1.308-11.075-12.819zm-20.941-14.34c7.804 3.363 15.298 7.808 20.941 14.34l-1.514 1.307c-5.367-6.213-12.556-10.508-20.219-13.811zm-17.658 2.109c1.664-.572 4.86-1.593 8.205-2.233 1.673-.32 3.407-.55 5.019-.575 1.599-.025 3.158.149 4.434.699l-.792 1.836c-.903-.389-2.139-.558-3.61-.536-1.458.023-3.069.233-4.675.54-3.211.615-6.305 1.602-7.93 2.161zm-2.432 1.705a5.47 5.47 0 0 1 2.432-1.705l.651 1.892a3.46 3.46 0 0 0-1.541 1.086z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M494.411 206.559a2 2 0 0 0 1.507 2.411l33.844 7.623c-.94-2.22-1.923-4.754-2.081-5.974-.2-1.545.694-2.744 1.373-3.414l-31.106-7.006a2 2 0 0 0-2.386 1.491zm41.116 2.104 7.016 10.809 45.428 10.233a2 2 0 0 0 2.386-1.491l1.152-4.869a2 2 0 0 0-1.507-2.411z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M114.546 23c2.51 0 4.545-2.239 4.545-5s-2.035-5-4.545-5c-2.511 0-4.546 2.239-4.546 5s2.035 5 4.546 5M130 23c2.511 0 4.546-2.239 4.546-5s-2.035-5-4.546-5c-2.51 0-4.545 2.239-4.545 5s2.035 5 4.545 5m20.909-5c0 2.761-2.035 5-4.545 5-2.511 0-4.546-2.239-4.546-5s2.035-5 4.546-5c2.51 0 4.545 2.239 4.545 5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "M118.091 18c0 2.301-1.675 4-3.545 4v2c3.15 0 5.545-2.778 5.545-6zm-3.545-4c1.87 0 3.545 1.699 3.545 4h2c0-3.222-2.395-6-5.545-6zM111 18c0-2.301 1.675-4 3.546-4v-2c-3.151 0-5.546 2.778-5.546 6zm3.546 4c-1.871 0-3.546-1.699-3.546-4h-2c0 3.222 2.395 6 5.546 6zm19-4c0 2.301-1.675 4-3.546 4v2c3.15 0 5.546-2.778 5.546-6zM130 14c1.871 0 3.546 1.699 3.546 4h2c0-3.222-2.396-6-5.546-6zm-3.545 4c0-2.301 1.675-4 3.545-4v-2c-3.15 0-5.545 2.778-5.545 6zM130 22c-1.87 0-3.545-1.699-3.545-4h-2c0 3.222 2.395 6 5.545 6zm16.364 2c3.15 0 5.545-2.778 5.545-6h-2c0 2.301-1.675 4-3.545 4zm-5.546-6c0 3.222 2.396 6 5.546 6v-2c-1.871 0-3.546-1.699-3.546-4zm5.546-6c-3.15 0-5.546 2.778-5.546 6h2c0-2.301 1.675-4 3.546-4zm5.545 6c0-3.222-2.395-6-5.545-6v2c1.87 0 3.545 1.699 3.545 4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M548.411 385.528a4.89 4.89 0 0 0-6.161-1.175v0a3.32 3.32 0 0 0-1.692 3.185l.522 6.05c.268 3.105 1.315 6.088 2.964 8.733 1.752 2.811 4.067 6.664 5.82 10.081v0c4.653 9.07 10.827 17.413 19.346 23.009l28.892 18.977 17.147 10.482 1.21-18.286-16.505-17.066a76 76 0 0 0-21.475-15.553l-3.085-1.496s-6.434-2.704-10.051-6.65c-2.705-2.951-12.274-14.598-16.932-20.291ZM423.15 164.377l10.964-20.46a5.09 5.09 0 0 1 6.953-2.049v0a5.09 5.09 0 0 1 2.273 6.313l-8.496 21.649 11.956 4.134c7.445 2.574 10.433 11.502 6.036 18.038l-25.231 37.512q-.082.123-.183.233l-6.524 7.143-21.431-17.216a2 2 0 0 1-.565-2.393zM713.547 306.813c14.359-.658 21.052 17.542 9.687 26.343L663.69 379.27c-4.721 3.656-11.544 2.601-14.939-2.312L561 250l35.5-15.5 91.5 103 13.473-23.341a14.72 14.72 0 0 1 12.074-7.346z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M715.962 1002.2c-6.015 73.99.207 112.46-9.462 135.8-3.066 7.4-20.381 22.44-23.815 24.75-14.261 9.59 7.923-.8 66.554-31.15l14.261-129.4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M715.962 1002.2c-6.015 73.99.207 112.46-9.462 135.8-3.066 7.4-20.381 22.44-23.815 24.75-14.261 9.59 7.923-.8 66.554-31.15l14.261-129.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M518.796 1000.97c-19.814 71.51-34.144 123.27-45.51 150.04-4.052 9.55-12.477 8.2-16.286 10.49-15 9 13.904 6.51 68.398-30.76l46.996-136.348z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m662.5 501-157 502 76 1L721 585.202 707.71 1004.2h68.97l29.99-446.404a76 76 0 0 0-7.187-37.716L760 437l-74 8z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("mask", {
  id: "teamwork_svg__b",
  width: 304,
  height: 571,
  x: 504,
  y: 435,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m662.5 501-157 502 76 1L721 585.202 707.71 1004.2h68.97l29.99-446.404a76 76 0 0 0-7.187-37.716L760 437l-74 8z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M765.071 329.988c-.28-16.026-14.378-28.281-30.287-26.328l-6.278.771-52.701 6.471L658 316l28 128.5 61.651-3.045c10.785-.532 19.199-9.529 19.011-20.324z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m680.965 283.428 5.018 27.072-1.966.365-5.019-27.072zm39.077 22.54-10.858-36.386 1.916-.572 10.858 36.386z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m685.983 310.5.182.983.984-.182-.183-.983zm-5.018-27.072.983-.182-.182-.983-.984.182zm3.052 27.437-.984.182.183.983.983-.182zm-5.019-27.072-.182-.984-.983.183.182.983zm30.186-14.211-.286-.958-.958.286.286.958zm10.858 36.386-.959.286.286.958.959-.285zM711.1 269.01l.959-.286-.286-.958-.959.286zm10.858 36.386.286.959.958-.286-.286-.959zm-34.992 4.922-5.018-27.072-1.967.364L685 310.682zm-2.767 1.53 1.966-.365-.364-1.966-1.967.364zm-6.184-27.873 5.018 27.072 1.967-.365-5.019-27.072zm2.767-1.53-1.966.364.365 1.967 1.966-.365zm27.444-12.577 10.857 36.386 1.917-.572-10.858-36.386zm2.588-1.816-1.916.572.572 1.916 1.916-.572zm12.102 37.058-10.857-36.386-1.917.572L721 305.682zm-2.588 1.817 1.916-.572-.572-1.917-1.916.572z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M690.022 253.855a10.9 10.9 0 0 1 6.195-1.812c6.357.111 11.304 5.684 11.189 12.308-.082 4.665-2.641 8.699-6.363 10.657l-.931-1.77c3.059-1.609 5.225-4.968 5.294-8.922.099-5.646-4.093-10.183-9.224-10.273a8.88 8.88 0 0 0-5.061 1.483zm19.958 15.257 1.394-15.939c.442-16.524-13.552-26.378-29.386-23.736-17.184 2.867-20.807 12.189-24.325 29.448-3.517 17.259-.441 26.759 16.706 27.059 5.46.095 13.751-2.181 13.751-2.181",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m690.022 253.855-.55-.835-.835.549.55.836zm11.021 21.153-.885.465.466.885.885-.465zm-.931-1.77-.465-.885-.885.465.465.885zm-8.991-17.712-.835.549.55.836.835-.55zm17.863 13.499a1 1 0 1 0 1.992.174zm2.39-15.852.997.087.002-.03.001-.03zm-29.386-23.736-.164-.986zm-24.325 29.448-.979-.2zm30.722 25.842a1 1 0 0 0-.53-1.928zm7.85-33.683a11.87 11.87 0 0 0-6.763 1.976l1.1 1.67a9.9 9.9 0 0 1 5.628-1.647zm12.171 13.324c.124-7.111-5.2-13.203-12.171-13.324l-.035 1.999c5.742.101 10.313 5.154 10.206 11.291zm-6.897 11.525c4.053-2.132 6.809-6.504 6.897-11.525l-2-.034c-.075 4.309-2.438 8.005-5.828 9.789zm-2.282-2.19.931 1.77 1.77-.931-.931-1.77zm5.179-9.404c-.063 3.598-2.032 6.619-4.759 8.054l.931 1.77c3.39-1.784 5.753-5.48 5.828-9.789zm-8.241-9.256c4.519.079 8.331 4.101 8.241 9.256l2 .035c.107-6.138-4.464-11.191-10.206-11.291zm-4.494 1.318a7.9 7.9 0 0 1 4.494-1.318l.035-2a9.9 9.9 0 0 0-5.628 1.647zm-2.484-1.956 1.099 1.67 1.671-1.099-1.1-1.671zm21.789 14.794 1.395-15.939-1.993-.174-1.394 15.939zm1.398-15.999c.229-8.572-3.296-15.474-8.977-19.873-5.667-4.388-13.413-6.238-21.573-4.876l.329 1.972c7.673-1.28 14.841.476 20.019 4.486 5.164 3.998 8.415 10.285 8.203 18.237zm-30.55-24.749c-8.773 1.463-14.245 4.61-17.934 9.728-3.635 5.043-5.451 11.891-7.206 20.506l1.959.399c1.762-8.644 3.517-15.085 6.869-19.735 3.298-4.575 8.229-7.522 16.641-8.926zm-25.14 30.234c-1.763 8.649-1.952 15.657.704 20.565 2.723 5.033 8.232 7.541 16.963 7.694l.035-2c-8.415-.147-13.017-2.538-15.239-6.646-2.29-4.231-2.259-10.604-.504-19.214zm17.667 28.259c2.844.049 6.371-.515 9.139-1.075a87 87 0 0 0 4.516-1.041l.278-.074.074-.02.019-.005.005-.001.002-.001-.264-.964-.265-.964h-.001l-.004.001-.016.004-.068.019-.266.07a85.62 85.62 0 0 1-4.406 1.016c-2.743.554-6.092 1.08-8.708 1.035z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M687.837 283.715 682.5 300l-1.612-13.988z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m598.645 433.116-4 19Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m598.645 433.116-4 19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M654.105 313.009c-7.294-2.342-14.831 2.846-15.249 10.495L632.682 436.5l-39-24-.182 44.5 41.859 22.326c17.829 9.51 39.553-2.421 41.095-22.568l7.595-99.209c1.531-19.988-10.857-38.414-29.944-44.54z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M660 232.734c0 3.908 3 8 3 8l.202-.093c1.012.701 5.697 3.886 10.798 6.359 5.765 2.795 16 7.5 16 7.5s4.349-2.452 6.889-2.222c1.576.143 4.308 2.385 4.308 2.385s4.229 5.258 5.303 8.837-1 5.5-1 5.5l4.5.182 1.122-4.208c.583-2.185.878-4.437.878-6.699v-3.473c0-4.967-1.479-9.821-4.25-13.944l-3.081-4.585s-.169-3.591-9.169-5.591a182 182 0 0 1-3.15-.731 29.2 29.2 0 0 0-9.234-.72c-1.188-.597-3.092-1.367-6.116-2.231-13.787-3.939-17 1.5-17 5.734M653.469 1169.33c-6.469 2.18-9.354 9.71-5.995 15.66l68.64.2a7.96 7.96 0 0 0 5.677-2.34l17.317-17.29-2.49 19.43H758l-3.109-49.32a5.84 5.84 0 0 0-5.823-5.47s-33.688 19.43-51.793 27.39c-18.105 7.97-8.964 0-8.964 0zM430.469 1169.33c-6.469 2.18-9.354 9.71-5.995 15.66l68.64.2a7.96 7.96 0 0 0 5.677-2.34l17.317-17.29-2.49 19.43H535l-3.109-49.32a5.84 5.84 0 0 0-5.823-5.47s-33.688 19.43-51.793 27.39c-18.105 7.97-8.964 0-8.964 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M270 1128v24l40 4 7-36",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M270 1128v24l40 4 7-36"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M118.031 1130 102 1184h54l-8.437-54",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M118.031 1130 102 1184h54l-8.437-54"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M82.62 628.08a24.9 24.9 0 0 1-8.815 12.561l-3.78 2.848a13.49 13.49 0 0 1-9.994 2.585v0c-14.559-2.046-21.91-18.664-13.63-30.813l6.835-10.03 18.743-29.176 5.633-39.687 12.693 8.981 7.309 34.064z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M152.949 257.5a30 30 0 0 0-28.781 21.538L39.5 567H97l85.5-309.5z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m253.53 369.322-2.999 48.327a77 77 0 0 1-8.617 30.911L237.5 457h-123l-1.761-5.622a77 77 0 0 1-1.563-40.278l30.528-132.745c2.81-12.218 13.659-20.894 26.195-20.949l46.649-.204c10.99-.049 20.985 4.015 28.586 10.708a27 27 0 0 1 4.03 2.712L316 326.5l75.146-120.478 49 23-93.176 168.29c-8.077 14.589-27.035 18.928-40.653 9.306z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m253.53 369.322.577-.817-1.464-1.034-.111 1.789zm-2.999 48.327-.998-.062zm-8.617 30.911-.887-.464zM237.5 457v1h.606l.28-.537zm-123 0-.954.299.219.701h.735zm-1.761-5.622-.954.299zm-1.563-40.278.974.224zm30.528-132.745-.974-.225zm26.195-20.949.004 1zm46.649-.204.004 1zm28.586 10.708-.661.75.082.073.097.053zm4.03 2.712-.63.776zM316 326.5l-.63.776.879.714.6-.961zm75.146-120.478.425-.905-.803-.377-.47.753zm49 23 .875.484.518-.935-.968-.454zm-93.176 168.29-.875-.484zm-40.653 9.306.577-.817zm-53.785-37.358-2.999 48.327 1.996.124 2.999-48.327zm-2.999 48.327a76 76 0 0 1-8.506 30.509l1.773.927a78 78 0 0 0 8.729-31.312zm-8.506 30.509-4.413 8.441 1.772.926 4.414-8.44zM237.5 456h-123v2h123zm-122.046.701-1.761-5.621-1.908.597 1.761 5.622zm-1.761-5.621a76 76 0 0 1-1.543-39.756l-1.949-.448a78 78 0 0 0 1.584 40.801zm-1.543-39.756 30.529-132.745-1.949-.449-30.529 132.746zm30.529-132.745c2.705-11.765 13.153-20.12 25.224-20.173l-.009-2c-13 .057-24.251 9.055-27.164 21.724zm25.224-20.173 46.649-.204-.008-2-46.65.204zm46.649-.204a41.8 41.8 0 0 1 27.921 10.458l1.321-1.501c-7.777-6.848-18.006-11.007-29.25-10.957zm28.1 10.584a26 26 0 0 1 3.882 2.612l1.261-1.553a28 28 0 0 0-4.18-2.812zm3.882 2.612 68.836 55.878 1.26-1.552-68.835-55.879zm70.315 55.631 75.146-120.478-1.697-1.058-75.146 120.478zm73.872-120.102 49 23 .85-1.81-49-23zm48.551 21.611-93.177 168.29 1.75.969 93.176-168.291zm-93.177 168.29c-7.788 14.067-26.069 18.252-39.201 8.973l-1.154 1.634c14.105 9.965 33.739 5.471 42.105-9.638zm-39.201 8.973-52.787-37.296-1.154 1.634 52.787 37.296z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M196.543 218.023v-16c1-16.5 15.8-25.097 31.343-21.085 16.868 4.354 20.157 17.085 22.157 34.585s-1.893 24.696-19 23.5c-5.448-.381-14-4.5-14-4.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M196.543 218.023v-16c1-16.5 15.8-25.097 31.343-21.085 16.868 4.354 20.157 17.085 22.157 34.585s-1.893 24.696-19 23.5c-5.448-.381-14-4.5-14-4.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M205.472 223.834c-3.222-2.073-5.253-5.961-4.952-10.261.428-6.121 5.42-10.758 11.151-10.357a9.87 9.87 0 0 1 5.463 2.131",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M205.472 223.834c-3.222-2.073-5.253-5.961-4.952-10.261.428-6.121 5.42-10.758 11.151-10.357a9.87 9.87 0 0 1 5.463 2.131"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "m218.346 208.447.697-10.424 27-3.047s-2.856-4.284-4.46-6.035c-8.831-9.648-15.589-9.152-18.887-8.911q-.27.021-.508.036c-7.552.474-12.714 2.62-12.714 2.62s-.623 1.039-7.777 5.438-6.154 28.399-6.154 28.399l5.5-.047.74.179a9.5 9.5 0 0 1 9.922-11.609 9.47 9.47 0 0 1 6.641 3.401M268.098 1142 262 1175.63V1186h106.512s10.281-2.73 11.142-7.21 2.898-12.51-33.87-19.38c-7.786-1.45-10.058-5.31-17.949-10.33-3.517-2.24-16.566-7.08-16.566-7.08s-4.466 5.86-19.577 7.08-23.594-7.08-23.594-7.08M113.5 1144.5l-13.5 40.54h57.489999999999995l-7.99-40.54zM700.5 274l-5 36 10.838 12.207c15.944 17.958 45.421 11.343 52.162-11.707l-46.5-53s-3.686 3.559-5.5 9-6 7.5-6 7.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M114.23 457h123.385L317 829l4 301h-55.31l-24.698-284.008-65.495-268.814L157.5 1130h-51.056L87 567s10.252-56.826 15-70.5 12.23-39.5 12.23-39.5Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M156 577h19Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M156 577h19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m293 202.5 24.5 24.5Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m293 202.5 24.5 24.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m293 227 24.5-24.5Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m293 227 24.5-24.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M174.5 257.5 181 239l46 7-3 13z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M633 431.5v10Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M633 431.5v10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m253.5 369.5-22.5-16Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m253.5 369.5-22.5-16"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "teamwork_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.394 0H853v1186H.394z"
})))));
export default SvgTeamwork;